<template>
  <div :class="classes">
    <font-awesome-icon v-if="icon" :icon="icon" class="px-1"></font-awesome-icon>
    <slot></slot>
  </div>
</template>

<script>
  import { computed } from 'vue';

  import FontAwesomeIcon from '@/components/FontAwesomeIcon.vue';

  export default {
    name: "AlertBox",

    components: {
      FontAwesomeIcon
    },

    props: {
      level: {
        type: String,
        required: false,
        default: "notice",
        validator: function(value) {
          return ['success', 'alert', 'notice'].indexOf(value) !== -1
        }
      },

      icon: {
        type: [String, Array],
        required: false
      },

      isSmall: {
        type: Boolean
      }
    },

    setup(props) {
      return {
        classes: computed(() => {
          return ['alert-box', props.level, { small: props.isSmall }];
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import 'colors';

  .alert-box {
    background: $grey-1;
    color: $blue-grey-5;
    border-radius: 3px;

    &.small {
      font-size: 0.9325rem;
    }

    &.error {
      color: $error-2;
    }
  }
</style>
